/**
 * "Fit to data" for the 2D and 3D scatters (`xFit`, `yFit`, `zFit`): an axis runs from the smallest to the
 * largest value shown; a single value gets one unit on each side; without values the set range stays.
 */
export function axisRange(
  values: number[],
  fit: boolean | undefined,
  min: number,
  max: number,
): { min: number; max: number } {
  const finite = values.filter(Number.isFinite);
  if (!fit || finite.length === 0) return { min, max };
  const lo = Math.min(...finite);
  const hi = Math.max(...finite);
  return lo === hi ? { min: lo - 1, max: hi + 1 } : { min: lo, max: hi };
}
